import React from 'react'
import styled from 'styled-components'
import { WithAuth as Root } from '@/components/Root'
import { PreUsersTable } from '@/components/tables/PreUsersTable'
import { Layout, PageHeader } from 'antd'

const pageTitle = '顧客番号/PINコード管理'

export default () => (
  <Root title={pageTitle}>
    <Layout>
      <StyledPageHeader title={pageTitle} />
      <PreUsersTable />
    </Layout>
  </Root>
)

const StyledPageHeader = styled(PageHeader)`
  margin: 16px 0;
  background-color: #fff;
`
